import Header from '../components/Header';
import Footer from '../components/Footer';
import { Shield, Lock } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-dark-bg">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <article className="bg-dark-card border-2 border-gray-800 rounded-2xl p-8 md:p-12">
            <div className="flex items-center mb-6">
              <Shield className="w-8 h-8 text-toxic-green mr-4" />
              <h1 className="text-4xl md:text-5xl font-bold text-white">
                Politique de Confidentialité
              </h1>
            </div>

            <div className="prose prose-invert max-w-none">
              <p className="text-gray-400 mb-8 text-sm">
                Dernière mise à jour : 26 novembre 2025
              </p>

              <p className="text-gray-300 mb-6 leading-relaxed">
                Hexabet Connect s'engage à protéger votre vie privée et vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons, stockons et protégeons vos informations lorsque vous utilisez notre site web hexabetconnect.com.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                1. Données que Nous Collectons
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous collectons différentes catégories de données personnelles lorsque vous utilisez notre site :
              </p>
              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Données d'Identification
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Lorsque vous créez un compte ou nous contactez via notre formulaire, nous collectons votre nom, prénom, adresse email, et numéro de téléphone si vous le fournissez. Ces informations sont nécessaires pour vous identifier et communiquer avec vous.
              </p>
              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Données de Navigation
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous collectons automatiquement des informations sur votre utilisation de notre site, notamment votre adresse IP, le type de navigateur, les pages visitées, la durée de visite, et les liens sur lesquels vous cliquez. Ces données nous aident à améliorer notre site et à comprendre comment vous l'utilisez.
              </p>
              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Cookies et Technologies Similaires
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous utilisons des cookies et des technologies similaires pour améliorer votre expérience, analyser l'utilisation du site, et personnaliser le contenu. Pour plus d'informations, consultez notre Politique des Cookies.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                2. Comment Nous Utilisons Vos Données
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous utilisons vos données personnelles pour les finalités suivantes :
              </p>
              <ul className="list-disc list-inside space-y-3 text-gray-300 mb-6 ml-4">
                <li>Fournir et améliorer nos services de comparaison et d'information</li>
                <li>Répondre à vos demandes et questions via notre formulaire de contact</li>
                <li>Vous envoyer des communications importantes concernant nos services</li>
                <li>Analyser l'utilisation de notre site pour l'améliorer</li>
                <li>Respecter nos obligations légales et réglementaires</li>
                <li>Détecter et prévenir la fraude ou les abus</li>
                <li>Personnaliser votre expérience sur notre site</li>
              </ul>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                3. Base Légale du Traitement
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Conformément au Règlement Général sur la Protection des Données (RGPD), nous traitons vos données personnelles sur les bases légales suivantes :
              </p>
              <ul className="list-disc list-inside space-y-3 text-gray-300 mb-6 ml-4">
                <li><strong>Consentement :</strong> Lorsque vous nous donnez votre consentement explicite pour certaines utilisations de vos données</li>
                <li><strong>Exécution d'un contrat :</strong> Pour fournir les services que vous demandez</li>
                <li><strong>Obligation légale :</strong> Pour respecter nos obligations légales et réglementaires</li>
                <li><strong>Intérêt légitime :</strong> Pour améliorer nos services et analyser l'utilisation du site, dans le respect de vos droits et libertés</li>
              </ul>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                4. Partage de Vos Données
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous ne vendons jamais vos données personnelles à des tiers. Nous pouvons partager vos données dans les cas suivants :
              </p>
              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Prestataires de Services
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous pouvons partager vos données avec des prestataires de services qui nous aident à exploiter notre site (hébergement, analyse, email). Ces prestataires sont contractuellement tenus de protéger vos données et de ne les utiliser que pour les finalités que nous leur avons assignées.
              </p>
              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Obligations Légales
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous pouvons divulguer vos données si la loi l'exige, en réponse à une demande judiciaire, ou pour protéger nos droits, votre sécurité, ou celle d'autrui.
              </p>
              <h3 className="text-2xl font-bold mt-8 mb-4 text-white">
                Liens d'Affiliation
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Lorsque vous cliquez sur un lien d'affiliation vers une plateforme de paris, vous quittez notre site et êtes soumis à la politique de confidentialité de cette plateforme. Nous ne partageons pas vos données personnelles avec ces plateformes, sauf si vous créez un compte directement via notre lien.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                5. Conservation de Vos Données
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous conservons vos données personnelles aussi longtemps que nécessaire pour les finalités pour lesquelles elles ont été collectées, ou conformément aux obligations légales applicables. Les données de contact sont conservées jusqu'à ce que vous demandiez leur suppression ou que nous n'en ayons plus besoin.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les données de navigation et les cookies sont conservés selon les durées indiquées dans notre Politique des Cookies. Certaines données peuvent être conservées plus longtemps si la loi l'exige ou pour des raisons légitimes de sécurité.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                6. Vos Droits
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Conformément au RGPD, vous disposez des droits suivants concernant vos données personnelles :
              </p>
              <ul className="list-disc list-inside space-y-3 text-gray-300 mb-6 ml-4">
                <li><strong>Droit d'accès :</strong> Vous pouvez demander une copie de vos données personnelles que nous détenons</li>
                <li><strong>Droit de rectification :</strong> Vous pouvez demander la correction de données inexactes ou incomplètes</li>
                <li><strong>Droit à l'effacement :</strong> Vous pouvez demander la suppression de vos données dans certaines circonstances</li>
                <li><strong>Droit à la limitation :</strong> Vous pouvez demander la limitation du traitement de vos données</li>
                <li><strong>Droit à la portabilité :</strong> Vous pouvez demander le transfert de vos données vers un autre service</li>
                <li><strong>Droit d'opposition :</strong> Vous pouvez vous opposer au traitement de vos données pour certaines finalités</li>
                <li><strong>Droit de retirer votre consentement :</strong> Si le traitement est basé sur votre consentement, vous pouvez le retirer à tout moment</li>
              </ul>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Pour exercer ces droits, contactez-nous à l'adresse : info@hexabetconnect.com. Nous répondrons à votre demande dans un délai d'un mois.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                7. Sécurité de Vos Données
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre l'accès non autorisé, la perte, la destruction ou l'altération. Ces mesures incluent le cryptage SSL/TLS, l'accès restreint aux données, et des procédures de sécurité régulières.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Cependant, aucune méthode de transmission sur Internet ou de stockage électronique n'est totalement sécurisée. Bien que nous nous efforcions de protéger vos données, nous ne pouvons garantir une sécurité absolue.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                8. Transferts Internationaux
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Vos données personnelles sont principalement stockées et traitées dans l'Union Européenne. Si nous devons transférer vos données vers un pays tiers, nous nous assurons que des garanties appropriées sont en place pour protéger vos données conformément au RGPD.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                9. Modifications de Cette Politique
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Nous pouvons modifier cette politique de confidentialité de temps à autre pour refléter les changements dans nos pratiques ou pour d'autres raisons opérationnelles, légales ou réglementaires. Nous vous informerons de tout changement significatif en publiant la nouvelle politique sur cette page avec une date de mise à jour révisée.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                10. Contact
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, contactez-nous :
              </p>
              <div className="bg-toxic-green/10 border border-toxic-green/30 rounded-xl p-6 mt-6">
                <p className="text-gray-300 mb-2"><strong>Email :</strong> info@hexabetconnect.com</p>
                <p className="text-gray-300 mb-2"><strong>Téléphone :</strong> +33 4 21 73 98 33</p>
                <p className="text-gray-300"><strong>Adresse :</strong> Paris, France</p>
              </div>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;

